export default __webpack_public_path__ + "static/Physiolymp_Kontakt_2023-b2fa56f2876583f4d81d1da37aa2006f.png";